import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AdsEmpty.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const AdsEmpty = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <IconBox $filename="ads-empty.svg" $width={177} $height={123} />
      <S.Text $variant="1">
        {t('pages.cabinet.there_are_no_ads_in_this_section')}
      </S.Text>
    </S.Box>
  );
};
